var global = require('./_global')
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_shared.js
// module id = 188
// module chunks = 48 49 50 51